export const COLOR_AZUL_MAIN = '#0F3457';